<template>
  <div class="GlobalTable" v-if="refresh">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      :pageSize="page.pageSize"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="发货联系人" slot="senderName" align="center">
        <template slot-scope="{ row }">
          <span> {{ row.senderName }}-{{ row.senderTel }}</span>
        </template>
      </el-table-column>
      <el-table-column label="服务单号" slot="orderNumber" align="center">
        <template slot-scope="{ row }">
          <span class="text-down" @click="openOrderListDia(row)"> {{ row.orderNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" slot="mode" align="center">
        <template slot-scope="{ row }">
         {{ row.mode == 1?'移动':"联通" }}
        </template>
      </el-table-column>
      <el-table-column label="预约取件时间" slot="subscribeTime" align="center" v-if="state === 1">
        <template slot-scope="{ row }">
          <span style="color: #ff687b;"> {{ row.subscribeTime }}</span>
        </template>
      </el-table-column>
      <template v-if="state === 6">
        <el-table-column label="物流费用" slot="fee" align="center">
          <template slot-scope="{ row }">
            <span> {{ row.fee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="签收时间" slot="signTime" align="center">
          <template slot-scope="{ row }">
            <span> {{ row.signTime }}</span>
          </template>
        </el-table-column>
      </template>
      <template v-if="state === 7">
        <el-table-column label="取消时间" slot="cancelTime" align="center">
          <template slot-scope="{ row }">
            <span> {{ row.cancelTime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="取消操作人" slot="cancel" align="center">
          <template slot-scope="{ row }">
            <span> {{ row.cancelTime }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="取消原因" slot="cancelTypeEnum" align="center">
          <template slot-scope="{ row }">
            <span> {{ row.cancelTypeEnum }}</span>
          </template>
        </el-table-column>
      </template>
      <!-- 照片待定，目前不做 -->
      <!-- <el-table-column label="发货拍照" align="center" slot="sendProof" v-if="state !== 1">
        <template slot-scope="{ row }">
          <div
            class="images-box"
            v-if="row.sendProof || row.sendProof1"
          >
            <img :src="row.sendProof || row.sendProof1" alt="" />
            <span @click="openImgBox(row)" class="text-down"
              >共<span>{{
                row.sendProof && row.sendProof1 ? 2 : 1
              }}</span>
              张</span
            >
          </div>
          <div v-else>暂无图片</div>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        slot="operation"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="primary"
            round
            @click="handleBtn(row)"
            >查看物流详情
          </el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 备注弹出框 -->
    <!--弹框-->
    <el-dialog
      class="acc_dialog"
      title="物流详情"
      :visible.sync="Logisticsdetails"
      :close-on-click-modal="false"
      width="810px"
    >
      <div v-loading="loading2">
        <div class="fzs18 b25">快递单号：{{ logisticsInfo.info.mailNumber }}</div>


        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div class="two">
            <div class="twoinfo">寄件人信息</div>
            <div class="twophone">
              {{ logisticsInfo.info.senderName }}-{{ logisticsInfo.info.senderTel }}
            </div>
            <div>
              {{logisticsInfo.info.senderAddress}}
            </div>
          </div>
          <div class="two">
            <div class="twoinfo">收件人信息</div>
            <div class="twophone">
              {{ logisticsInfo.info.receiverName }}-{{
                logisticsInfo.info.receiverTel
              }}
            </div>
            <div>
              {{logisticsInfo.info.receiverAddress}}
            </div>
          </div>
        </div>
        <div class="loacinfo">物流信息</div>

        <div class="three">
          <el-timeline
            v-if="
              this.logisticsInfo.list &&
              this.logisticsInfo.list.length
            "
          >
            <el-timeline-item
              v-for="(activity, index) in logisticsInfo.list"
              :key="index"
              :timestamp="activity.desc"
            >
              {{ activity.operateTime }}
            </el-timeline-item>
          </el-timeline>
          <p v-else style="width: 100%;text-align: center;font-size: 16px;">暂无物流信息</p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click.native="Logisticsdetails = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看旧机照片 -->
    <el-dialog
      :close-on-click-modal="false"
      :width="`${800}px`"
      title="查看发货拍照图片"
      :visible="imgShow"
      @close="imgClose"
      top="5%"
    >
      <div class="img-box">
        <div class="img-tips-box">
          <div
            class="img-tips"
            :class="imgShowOnly ? 'img-tips-default' : 'img-tips-choose'"
          >
            照片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList.length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList.length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item v-for="item in DialogImgList" :key="item">
                  <div class="sec_img">
                    <img :src="item" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="服务单列表"
      :visible.sync="orderListDiaShow"
      :close-on-click-modal="false"
      width="900px"
      top="100px"
    >
      <GlobalTable
        ref="orderListDia"
        v-loading="orderListLoading"
        :columns="orderListColumns"
        :data="orderList"
        :maxHeight="600"
        :isPagination="false"
      >
        <el-table-column label="营业员" slot="senderName" align="center">
          <template slot-scope="{ row }">
            <span> {{ row.senderName }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="orderListDiaShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import {orderLogistics,orderLogisticsInfo,serviceList} from "../../../utils/request/changePhone";

export default {
  name: "Table",
  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      offlineExpressId: "",
      isOnline: "",
      refresh: false,
      imgShow: false,
      imgShowOnly: true,
      DialogImgList: [],
      imgShowIndex: 0,
      state: 1,
      initData: null,
      loading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      tableColumns: [
        { prop: "channel", label: "服务商" },
        { slotName: "senderName" },
        { prop: "imei", label: "imei" },
        { prop: "mailNumber", label: "物流单号" },
        { prop: "orderTime", label: "下单时间" },
        { slotName: "orderNumber" },
        { prop: "estimatePrice", label: "回收价" },
        { slotName: "mode" },
        { slotName: "subscribeTime" },
        { slotName: "fee" },
        { slotName: "signTime" },
        { slotName: "cancelTime" },
        { slotName: "cancelTypeEnum" },
        // { slotName: "sendProof" }, //照片待定，目前不做
        { slotName: "operation" }, //操作
      ],
      // 弹框
      Logisticsdetails: false,
      logisticsInfo: {
        info: {},
        list: []
      },
      loading2: false,
      orderListDiaShow: false,
      orderListLoading: false,
      orderList: [],
      orderListColumns: [
        { prop: "orderNumber", label: "服务单号" },
        { prop: "modelMemory", label: "机型" },
        { slotName: "senderName" },
        { prop: "imei", label: "旧机IMEI码" },
        { prop: "backRetailPrice", label: "回收终端零售价" },
        { prop: "retailPrice", label: "实际终端零售价" },
        { prop: "estimatePrice", label: "回收价" },
      ],
    };
  },
  created() {
    this.refresh = true;
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    tabIndex(val) {
      this.refresh = false;
      if (val == 0) {
        this.state = 1;
      } else if (val == 1) {
        this.state = 2;
      } else if (val == 2) {
        this.state = 6;
      } else if (val == 3) {
        this.state = 7;
      }
      this.handleCurrentChange();
      // 在组件移除后，重新渲染组件
      this.refresh = true;
    },
    SeachParams(newVal) {
      console.log("====", newVal);
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        state: this.state,
        ...this.SeachParams,
        day: this.SeachParams.day,
        channel: this.SeachParams.channel,
        beg_time: this.SeachParams.beg_time,
        end_time: this.SeachParams.end_time,
        beg_signTime: this.SeachParams.beg_signTime,
        end_signTime: this.SeachParams.end_signTime,
        beg_cancelTime: this.SeachParams.beg_cancelTime ,
        end_cancelTime: this.SeachParams.end_cancelTime,
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      this.loading = true;
      orderLogistics(baseRequest).then((res) => {
        if (res.code === 1) {
          this.$emit("getSendData", res.data.tab);
          this.seachDataList = res.data.list
          this.page.total = Number(res.count);
          this.page.pageNum = Number(res.page);
          this.loading = false;
          this.initexpressNo = "";
        }
      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    openImgBox(row) {
      this.imgShow = true;
      if (row.sendProof1 != "--") {
        this.DialogImgList = [row.sendProof, row.sendProof1];
      } else {
        this.DialogImgList = [row.sendProof];
      }
    },
    // 弹出弹框
    handleBtn(row) {
      this.loading2 = true;
      this.Logisticsdetails = true;
      orderLogisticsInfo({ id: row.id }).then((res) => {
        console.log(res);
        this.logisticsInfo = res.data;
        this.loading2 = false;
      });
    },
    openOrderListDia(row) {
      this.orderListDiaShow = true;
      this.orderListLoading = true;
      this.orderList = []
      serviceList({id:row.id}).then(res => {
        if(res.code === 1){
          this.orderList = res.data
          this.orderListLoading = false;
        }
      })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .operation-btn {
    /deep/ .el-button {
      margin-left: 0;
    }
  }

  .button_top {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .faultBtn {
    width: 500px;
    height: 34px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;

    .active {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981ff;
      border-radius: 20px;
    }

    .none {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }

  .verify-title {
    color: #0981ff;
    line-height: 16px;
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid;
    margin-bottom: 10px;
  }

  .enable-tip {
    color: #ff8080;
    font-size: 14px;
    margin-bottom: 20px;

    .tip-sure {
      margin-top: 10px;
      color: #333333;
      font-size: 16px;
      text-align: center;
    }
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .mr-50 {
    margin-right: 50px;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .mr-10 {
    margin-right: 10px;
  }

  .font-w {
    font-weight: bold;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flex-jb {
    display: flex;
    justify-content: space-between;
  }

  .flex-as {
    display: flex;
    align-items: flex-start;
  }
}
.center_router{
  margin-top: 15px;
  background: #f5f6fa;
    border-radius: 6px;
    padding: 13px 33px 13px 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.images-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.images-box > img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}

.images-box > span {
  color: #0981ff;
  cursor: pointer;
}

.text-down {
  color: #0981ff;
  cursor: pointer;
  text-decoration: underline;
}

// 弹窗
.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }
}

.isdeal {
  background: #ff687b;
  margin-right: 5px;
  display: inline-block;
}

.sec_img {
  width: 20vw;
  height: 80vh;
  margin: auto;

  img {
    width: 20vw;
    height: 80vh;
    object-fit: contain;
  }
}

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.one {
  flex: 1;
  text-align: center;
}

.one_img {
  width: 38px;
  height: 11px;
}

.fzs18 {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
}

.b25 {
  margin-bottom: 15px;
}

.fzs14 {
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #666666;
}

.b03 {
  margin-bottom: 3px;
}

.two {
  max-height: 124px;
  background: #f5f6fa;
  border-radius: 6px;
  width: 360px;
  padding: 10px 13px 15px 13px;
  box-sizing: border-box;
}

.twoinfo {
  font-size: 16px;
  font-family: FZLanTingHei-DB-GBK;
  font-weight: 400;
  color: #0981ff;
  margin-bottom: 6px;
}

.twophone {
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  margin-bottom: 6px;
}

.loacinfo {
  font-size: 16px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  margin-top: 15px;
}

.three {
  min-height: 100px;
  background: #f9fbfd;
  border: 1px solid #c1d1ff;
  border-radius: 10px;
  margin-top: 12px;
  margin-bottom: 16px;
  max-height: 200px;
  overflow: auto;
  padding: 20px 20px;
  box-sizing: border-box;
  padding-bottom: 0;
}

.three::-webkit-scrollbar {
  width: 3px;
  // display: none;
}

/*定义滚动条轨道*/
.three::-webkit-scrollbar-track {
  border-radius: 10px;
  // display: none;
}

/*定义滑块*/
.three::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(27, 140, 236, 0.5);
  display: none;
}

.dainzhang {
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  line-height: 20px;
  font-size: 12px;
  color: #ffffff;
  margin-right: 6px;
}

.channeltype2 {
  height: 16px;
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  line-height: 20px;
  font-size: 12px;
  color: #ffffff;
  margin-right: 6px;
}

.channeltype3 {
  display: flex;
  align-items: center;
  height: 16px;
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  font-size: 12px;
  color: #ffffff;
  margin-right: 6px;
}

.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}


.mb-10 {
  margin-bottom: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mr-50 {
  margin-right: 50px;
}

.ml-10 {
  margin-left: 10px;
}

.mr-10 {
  margin-right: 10px;
}

.font-w {
  font-weight: bold;
}

.flex {
  display: flex;
  align-items: center;
}

.flex-jb {
  display: flex;
  justify-content: space-between;
}

.flex-as {
  display: flex;
  align-items: flex-start;
}

.cancel_dialog {
  width: 100%;

  > h2 {
    font-weight: 900;
    font-size: 12px;
    color: #ff687b;
  }

  > p {
    font-size: 14px;
    margin-top: 20px;
    color: #111;
    font-weight: 900;
    text-align: center;
  }

  .p_info {
    text-align: left;
    font-size: 14px;
    margin-top: 10px;
    color: #111;
    font-weight: 900;

    &:last-of-type {
      margin-bottom: 20px;
    }
  }

  > .code_box {
    margin-top: 30px;
    width: 60%;
  }

  .cancel_table {
    margin-bottom: 30px;
  }

  .cancel_text {
    margin-bottom: 10px;
    color: #000;
    font-size: 14px;
    font-weight: 900;
  }
  /deep/.el-icon-arrow-down {
    /deep/::before {
      content: "";
      display: block;
      font-size: 14px;
      visibility: hidden;
    }
  }
}
</style>
